import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-sale-home',
  templateUrl: './sale-home.component.html',
  styleUrls: ['./sale-home.component.css']
})
export class SaleHomeComponent implements OnInit {
  public err_validation: boolean;
  public err_internet_validation: boolean;

  public loading: boolean;
  public server: any;
  public lang: any;
  public username: any;
  public err: string;
  public err_password: boolean;
  constructor(public router: Router) { }

  ngOnInit() {
    this.lang = JSON.parse(<any>localStorage.getItem('lang'));
    this.username = JSON.parse(<any>localStorage.getItem('username'));
    if (this.username == null) { this.router.navigate(['/login']); }
    this.server = localStorage.getItem('server');
  }

}
